<template>
  <div v-show="show" :style="{ 'z-index': (currentZIndex-1)}">
    <div :style="{ 'z-index': (currentZIndex)}"
      class="dimmed_black" style="display:block;top:0"></div>
    <div :style="{ 'z-index': (currentZIndex+1)}"
      class="rew19_popContainer introAro" style="display: block;">
      <div class="rew19_popup_wrap">
        <h2>
          <span class="rew19_basketList_tit">정기구매 소개</span>
          <button class="rew19_basketList_btn" @click="onCancel"><span>닫기</span></button>
        </h2>
      </div>
      <div class="rew19_popup_cont">
          <img src="https://resource2018.nuskinkorea.co.kr/images/aro/pop_fin_01.jpg" alt="">
      </div><!--//rew19_popup_cont-->
      <div class="rew19_popup_btn">
        <button class="rew19_popFull activation" @click="onCancel">닫기</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentZIndex : 2000,
    }
  },
  watch: {
    show(show) {
      this.$modalAfterTreat(show);

      show && this.$nextTick(() => {
        let _this = this;
        _this.currentZIndex = _this.$getDimmMaxIndex() + 2;

        this.$el.focus();
      })
    }
  },
  updated: function () {
    this.$nextTick(function () {
      $(".rew19_popContainer.big .rew19_popup_cont").css('height', $(window).height() - 102);
    })
  },
  methods :{
    onClose(response) {
      let _this = this;

      _this.$emit('close', response, null);
    },
    onCancel() {
      this.onClose(false);
    },
    onOk() {
      this.onClose(true);
    },

    /**
     * Local
     */
    initData : function(){
      let _this = this;
    },


  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/popup/IntroAroDialog.vue